// extracted by mini-css-extract-plugin
var _1 = "ZVjJ4";
var _2 = "Vy7VN";
var _3 = "Nup_1";
var _4 = "HfbzI";
var _5 = "jVz5A";
export { _1 as "base", _2 as "dim", _3 as "size-lg", _4 as "size-md", _5 as "size-sm" }
